import { useTranslation } from 'next-i18next';

import { useV2Router } from './hooks/use-v2-router';
import { Button as ButtonV2 } from '@restworld/ui-ds-base';

function FreemiumUserUpgradeCard() {
  const router = useV2Router();
  const { t } = useTranslation('dashboard-page');
  const { t: tC } = useTranslation('common');

  return (
    <div className="w-full rounded-lg bg-black pt-6 pb-4 px-4 flex flex-col gap-[10px] items-center justify-center mt-4  bg-[url('/utils-assets/rw-logo-white.png')] bg-no-repeat bg-cover">
      <h1 className="text-xl font-bold w-full text-purple-50 font-praktikal-bold">
        <span className="block">{t('looking_for_staff')}</span>
        <span className="block"> {t('restworld_has_you_covered')}</span>
      </h1>
      <div className="w-full text-white font-normal text-base mb-15">{t('with_the_premium_service_key')}</div>
      <ButtonV2 size="sm" onClick={() => router.push('/employer/purchase')} fullwidth>
        {tC('purchase_trial')}
      </ButtonV2>
    </div>
  );
}

export default FreemiumUserUpgradeCard;
